import { $elementChild } from "@grindex-common/helpers/elements";
import { getCurrentPosition } from "@grindex-common/helpers/locationHelpers";
import { apiConfig } from "@grindex-common/helpers/apiConfig";
import { underscoreTemplateGrindex } from "@grindex-client/common/js/helpers/underscore-helper";

function init($views) {
	$views.forEach(($view) => {
		const $nearestBrowserPrompt = $elementChild($view, "nearestBrowserPrompt");

		let userLatitude = "";
		let userLongitude = "";

		$nearestBrowserPrompt.addEventListener("click", getUserCoords);

		const options = {
			enableHighAccuracy: true,
			timeout: 5000,
			maximumAge: 0,
		};

		const language = apiConfig.apiLanguage;
		const $address = $elementChild($view, "address");
		const $template = underscoreTemplateGrindex($elementChild($view, "location-template").innerHTML);
		const $error = $elementChild($view, "info");

		getUserCoords();

		function renderResults() {
			const $brands = $elementChild($view, "brands");
			const $services = $elementChild($view, "services");
			const $locationtypes = $elementChild($view, "location-types");

			var url = `/${language}/api/location/nearest`;

			if (userLatitude && userLongitude) {
				url = `${url}/?latitude=${userLatitude}&longitude=${userLongitude}`;
			}

			if ($brands) {
				url += addQueryParam(url, "brands", $brands.dataset.brands);
			}
			if ($services) {
				url += addQueryParam(url, "services", $services.dataset.services);
			}
			if ($locationtypes) {
				url += addQueryParam(url, "locationtypes", $locationtypes.dataset.locationtypes);
			}

			fetch(url, { method: "GET" })
				.then((response) => response.json())
				.then((res) => {
					if (res.Latitude && res.Latitude !== 0 && res.Longitude && res.Longitude !== 0) {
						$address.innerHTML = $template(res);
					} else {
						$error.classList.remove("hidden");
					}
				})
				.catch((err) => {
					$error.classList.remove("hidden");
					throw new Error("api search error, response: " + err);
				});
		}

		function addQueryParam(url, key, value) {
			if (value) {
				return url.indexOf("/?") >= 0 ? `&${key}=${value}` : `/?${key}=${value}`;
			}

			return "";
		}

		function getUserCoords() {
			getCurrentPosition(coordsFound.bind(this), noCoords.bind(this), options);
			return false;
		}

		function coordsFound(location) {
			if (typeof location !== "undefined") {
				userLatitude = location.latitude;
				userLongitude = location.longitude;
			}
			renderResults();
		}

		function noCoords(err) {
			console.warn("ERROR(" + err.code + "): " + err.message);
			renderResults();
		}
	});
}

export default {
	view: "nearestLocationBlock",
	init,
};
